import React, { useEffect, useState } from 'react';
import api from '../lib/api';
import { kr, dato, idag } from '../lib/format';
import { PageHeader, Card, Modal } from '../components/ui';
import { Plus, Trash2, Landmark, Calendar, ArrowLeft, CheckCircle2 } from 'lucide-react';

const tom = () => ({
  navn: '', kreditor: '', kontonr_kreditor: '',
  hovedstol_opprinnelig: 0, hovedstol_rest: 0,
  rentesats: 5.0, start_dato: idag(), slutt_dato: '',
  termin_intervall_mnd: 1, neste_termin_dato: '',
  konto_gjeld: 2220, konto_rente: 8150, konto_bank: 1920,
  notater: '', aktiv: true,
});

const Gjeld = () => {
  const [liste, setListe] = useState(null);
  const [valgt, setValgt] = useState(null);
  const [open, setOpen] = useState(false);
  const [s, setS] = useState(tom());
  const last = () => api.get('/gjeld').then((r) => setListe(r.data));
  useEffect(() => { last(); }, []);
  const lagre = async () => {
    if (!s.navn) { alert('Lånet må ha et navn.'); return; }
    await api.post('/gjeld', s); setOpen(false); last();
  };
  const slett = async (l) => {
    if (!window.confirm(`Slette lån ${l.navn}?`)) return;
    await api.delete(`/gjeld/${l.id}`); last();
  };
  if (!liste) return <span className="fm-text-muted">Laster…</span>;
  if (valgt) return <LaanDetalj id={valgt} onBack={() => { setValgt(null); last(); }} />;
  const sumRest = liste.reduce((s, l) => s + (l.hovedstol_rest || 0), 0);
  return (
    <>
      <PageHeader title="Gjeld" subtitle="Lån, avdrag og rente"
        actions={
          <button className="btn-primary" onClick={() => { setS(tom()); setOpen(true); }}>
            <Plus size={14} /> Nytt lån
          </button>
        } />
      <Card style={{ marginBottom: 12, padding: 16 }}>
        <div className="fm-text-muted" style={{ fontSize: 12 }}>Total restgjeld</div>
        <div style={{ fontSize: 22, fontWeight: 700 }}>{kr(sumRest)}</div>
      </Card>
      <Card style={{ padding: 0 }}>
        {liste.length === 0 ? (
          <div style={{ padding: 24, textAlign: 'center' }}>
            <Landmark size={32} className="fm-text-muted" />
            <p className="fm-text-muted" style={{ fontSize: 13 }}>Ingen lån registrert.</p>
          </div>
        ) : (
          <table>
            <thead><tr>
              <th>Navn</th><th>Kreditor</th>
              <th style={{ textAlign: 'right' }}>Opprinnelig</th>
              <th style={{ textAlign: 'right' }}>Rest</th>
              <th style={{ textAlign: 'right' }}>Rente</th>
              <th>Status</th><th></th>
            </tr></thead>
            <tbody>
              {liste.map((l) => (
                <tr key={l.id}>
                  <td><a onClick={() => setValgt(l.id)}
                         style={{ cursor: 'pointer', color: 'var(--theme-accent)' }}>{l.navn}</a></td>
                  <td>{l.kreditor || '—'}</td>
                  <td style={{ textAlign: 'right' }}>{kr(l.hovedstol_opprinnelig)}</td>
                  <td style={{ textAlign: 'right' }}><b>{kr(l.hovedstol_rest)}</b></td>
                  <td style={{ textAlign: 'right' }}>{(l.rentesats || 0).toFixed(2)} %</td>
                  <td><span className={`badge ${l.aktiv ? 'badge-success' : 'badge-neutral'}`}>
                    {l.aktiv ? 'Aktiv' : 'Innfridd'}</span></td>
                  <td><button className="btn-ghost" onClick={() => slett(l)}>
                    <Trash2 size={14} style={{ color: 'var(--theme-danger)' }} /></button></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Card>
      <Modal open={open} onClose={() => setOpen(false)} title="Nytt lån" width={680}
             footer={<>
               <button className="btn-ghost" onClick={() => setOpen(false)}>Avbryt</button>
               <button className="btn-primary" onClick={lagre}>Lagre</button>
             </>}>
        <div className="grid" style={{ gridTemplateColumns: '1fr 1fr', gap: 10 }}>
          <div><label>Navn på lånet *</label>
            <input value={s.navn} onChange={(e) => setS({ ...s, navn: e.target.value })} /></div>
          <div><label>Kreditor</label>
            <input value={s.kreditor} onChange={(e) => setS({ ...s, kreditor: e.target.value })} /></div>
          <div><label>Kontonr hos kreditor</label>
            <input value={s.kontonr_kreditor}
                   onChange={(e) => setS({ ...s, kontonr_kreditor: e.target.value })} /></div>
          <div><label>Rentesats (%)</label>
            <input type="number" step="0.01" value={s.rentesats}
                   onChange={(e) => setS({ ...s, rentesats: parseFloat(e.target.value || 0) })} /></div>
          <div><label>Hovedstol opprinnelig</label>
            <input type="number" step="0.01" value={s.hovedstol_opprinnelig}
                   onChange={(e) => {
                     const v = parseFloat(e.target.value || 0);
                     setS({ ...s, hovedstol_opprinnelig: v, hovedstol_rest: s.hovedstol_rest || v });
                   }} /></div>
          <div><label>Hovedstol rest</label>
            <input type="number" step="0.01" value={s.hovedstol_rest}
                   onChange={(e) => setS({ ...s, hovedstol_rest: parseFloat(e.target.value || 0) })} /></div>
          <div><label>Startdato</label>
            <input type="date" value={s.start_dato}
                   onChange={(e) => setS({ ...s, start_dato: e.target.value })} /></div>
          <div><label>Sluttdato</label>
            <input type="date" value={s.slutt_dato}
                   onChange={(e) => setS({ ...s, slutt_dato: e.target.value })} /></div>
          <div><label>Termin-intervall (mnd)</label>
            <input type="number" min="1" value={s.termin_intervall_mnd}
                   onChange={(e) => setS({ ...s, termin_intervall_mnd: parseInt(e.target.value || 1) })} /></div>
          <div><label>Neste termin</label>
            <input type="date" value={s.neste_termin_dato}
                   onChange={(e) => setS({ ...s, neste_termin_dato: e.target.value })} /></div>
          <div><label>Konto gjeld</label>
            <input type="number" value={s.konto_gjeld}
                   onChange={(e) => setS({ ...s, konto_gjeld: parseInt(e.target.value || 2220) })} /></div>
          <div><label>Konto rente</label>
            <input type="number" value={s.konto_rente}
                   onChange={(e) => setS({ ...s, konto_rente: parseInt(e.target.value || 8150) })} /></div>
          <div><label>Konto bank</label>
            <input type="number" value={s.konto_bank}
                   onChange={(e) => setS({ ...s, konto_bank: parseInt(e.target.value || 1920) })} /></div>
          <div style={{ gridColumn: '1 / -1' }}><label>Notater</label>
            <textarea rows={2} value={s.notater}
                      onChange={(e) => setS({ ...s, notater: e.target.value })} /></div>
        </div>
      </Modal>
    </>
  );
};

const LaanDetalj = ({ id, onBack }) => {
  const [laan, setLaan] = useState(null);
  const [terminer, setTerminer] = useState([]);
  const [n, setN] = useState(12);
  const last = () => {
    api.get(`/gjeld/${id}`).then((r) => setLaan(r.data));
    api.get(`/gjeld/${id}/terminer`).then((r) => setTerminer(r.data));
  };
  useEffect(() => { last(); }, [id]);
  const generer = async () => {
    if (!window.confirm(`Generere ${n} terminer? Eksisterende planlagte slettes.`)) return;
    await api.post(`/gjeld/${id}/generer`, { antall: n }); last();
  };
  const bokfor = async (t) => {
    if (!window.confirm(`Bokføre termin #${t.nummer}?`)) return;
    await api.post(`/gjeld/termin/${t.id}/bokfor`, {}); last();
  };
  if (!laan) return <span className="fm-text-muted">Laster…</span>;
  return (
    <>
      <button className="btn-ghost" onClick={onBack}><ArrowLeft size={14} /> Tilbake</button>
      <PageHeader title={laan.navn} subtitle={`${laan.kreditor || ''} • Rente ${laan.rentesats}%`} />
      <div className="grid" style={{ gridTemplateColumns: 'repeat(3, 1fr)', gap: 12, marginBottom: 12 }}>
        <Card style={{ padding: 14 }}>
          <div className="fm-text-muted" style={{ fontSize: 11 }}>Hovedstol</div>
          <div style={{ fontWeight: 700 }}>{kr(laan.hovedstol_opprinnelig)}</div></Card>
        <Card style={{ padding: 14 }}>
          <div className="fm-text-muted" style={{ fontSize: 11 }}>Restgjeld</div>
          <div style={{ fontWeight: 700, color: 'var(--theme-danger)' }}>{kr(laan.hovedstol_rest)}</div></Card>
        <Card style={{ padding: 14 }}>
          <div className="fm-text-muted" style={{ fontSize: 11 }}>Neste termin</div>
          <div style={{ fontWeight: 700 }}>{laan.neste_termin_dato ? dato(laan.neste_termin_dato) : '—'}</div></Card>
      </div>
      <Card style={{ marginBottom: 12, padding: 12 }}>
        <div className="flex items-center" style={{ gap: 8 }}>
          <Calendar size={16} />
          <label style={{ margin: 0 }}>Antall terminer:</label>
          <input type="number" min="1" value={n} style={{ width: 80 }}
                 onChange={(e) => setN(parseInt(e.target.value || 1))} />
          <button className="btn-secondary" onClick={generer}>Generer amortiseringsplan</button>
        </div>
      </Card>
      <Card style={{ padding: 0 }}>
        {terminer.length === 0 ? (
          <div style={{ padding: 20, textAlign: 'center' }} className="fm-text-muted">
            Ingen terminer ennå. Generer en plan over.
          </div>
        ) : (
          <table>
            <thead><tr>
              <th>#</th><th>Dato</th>
              <th style={{ textAlign: 'right' }}>Avdrag</th>
              <th style={{ textAlign: 'right' }}>Rente</th>
              <th style={{ textAlign: 'right' }}>Restgjeld</th>
              <th>Status</th><th></th>
            </tr></thead>
            <tbody>
              {terminer.map((t) => (
                <tr key={t.id}>
                  <td>{t.nummer}</td>
                  <td>{dato(t.dato)}</td>
                  <td style={{ textAlign: 'right' }}>{kr(t.avdrag)}</td>
                  <td style={{ textAlign: 'right' }}>{kr(t.rente)}</td>
                  <td style={{ textAlign: 'right' }}>{kr(t.restgjeld)}</td>
                  <td><span className={`badge ${t.status === 'bokfort' ? 'badge-success' : 'badge-neutral'}`}>
                    {t.status}</span></td>
                  <td>{t.status !== 'bokfort' && (
                    <button className="btn-ghost" onClick={() => bokfor(t)}>
                      <CheckCircle2 size={14} style={{ color: 'var(--theme-success)' }} /> Bokfør
                    </button>
                  )}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Card>
    </>
  );
};

export default Gjeld;
